import compact from 'lodash/compact'
import uniq from 'lodash/uniq'

type DaysByRow = Record<string, string[]>

const useRowAndEmployeeSelection = (
  allEmployees: boolean,
  daysByRow: DaysByRow,
  employeeIds: number[]
): DaysByRow => {
  const selectedDays: string[] = compact(uniq(Object.values(daysByRow).flat()))
  // Build a hash using the employeeIds as keys and the selected days as values like
  // employeeIds: [1, 2, 3]
  // selectedDays: ['2023-02-02', '2023-02-03']
  // => {1: ['2023-02-02', '2023-02-03'], 2: ['2023-02-02', '2023-02-03']...}
  if (allEmployees) return { ['all']: selectedDays }

  return employeeIds.reduce((hash: DaysByRow, employeeId) => {
    hash[employeeId] = selectedDays
    return hash
  }, {})
}

export default useRowAndEmployeeSelection
